<template>
<div class="eventlog-popup" v-bind:style="{display: toggled ? 'inline-block' : 'none'}" v-if="toggled">
    <div class="background" v-on:click="Close()"></div>
    <div class="employee-type-table">
        <div class="header">
            <div class="label">{{ $t('global.ui.lastChanges') }}</div>
        </div>
        <div class="table-container" v-if="!loading">
            <datatablesimple :state="logTableState"/>
        </div>
        <div v-if="loading" class="loading-md eventlog bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import datatable from './uicomponents/datatable.vue';
    import datatablesimple from './uicomponents/datatablesimple.vue';
    import { mapState, mapGetters } from 'vuex';
    import VueEventBus from '../vue-event-bus';
    export default {
        name: 'eventlog',
        components: {
            datatable,
            datatablesimple
        },
        data () {
            return {
                loading: true,
                loadingText: this.$t('global.ui.loadX', [this.$t('global.ui.history')]),
                toggled: false,
                logTypeMap: {},
                logActionMap: {}
            }
        },
        created: function () {
            VueEventBus.$on("toggle-eventlog", this.Toggle); 
        },
        mounted: function (){
            this.$helpers.log(this, 'mounted', null);
        },
        beforeDestroy() {
            VueEventBus.$off("toggle-eventlog", this.Toggle); 
        },
        computed: {
            ...mapGetters(['storeId', 'eventLogArray', 'uiDataMap', 'employeeMap', 'spotMap', 'planshiftMap']),
            logTableState() {
                let view = this;
                let state = {};
                
                let tableLogs = [];
                
                this.eventLogArray.forEach((l) => {
                    let date = this.$helpers.getMomentFromStringTZ(l.date).format('lll');
                    let type = view.logTypeMap[l.type] ? view.translateLogType(view.logTypeMap[l.type].label, l.count > 1) : '-';
                    let action = view.logActionMap[l.action] ? view.translateLogAction(view.logActionMap[l.action].label, l.count > 1) : '-';
                    let responsible = l.name;
                    tableLogs.push({
                        'date': date,
                        'type': l.count + ' ' + type,
                        'action': action,
                        'data': l.data ? l.data.date ? this.$helpers.getMomentFromStringTZ(l.data.date).format("DD.MM.YYYY") : '' : '',
                        'user': responsible,
                        'log': l
                    });
                });
                let columns = {
                    date: '',
                    type: '',
                    action: '',
                    user: '',
                    actions: '',
                }
                state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, tableLogs);
                state.headerMap['date'].componentStateBuilders = [(data, entry) => {
                    return {
                            componentType: 'labelc', 
                            state:{ 
                                text: (data.date), 
                                },
                                styleLabel: {display: 'flex', alignItems: 'center', justifyContent: 'center',background: '', height: 'calc(100% - 10px)'
                            },
                    }
                }]
                state.headerMap['type'].componentStateBuilders = [(data, entry) => {
                    return {
                            componentType: 'labelc', 
                            state:{ 
                                text: (data.type), 
                                },
                                styleLabel: {display: 'flex', alignItems: 'center', justifyContent: 'center',background: '', height: 'calc(100% - 10px)'
                            },
                    }
                }]
                state.headerMap['action'].componentStateBuilders = [(data, entry) => {
                    return {
                            componentType: 'labelc', 
                            state:{ 
                                text: (data.action), 
                                },
                                styleLabel: {display: 'flex', alignItems: 'center', justifyContent: 'center',background: '', height: 'calc(100% - 10px)'
                            },
                    }
                }]
                state.headerMap['user'].componentStateBuilders = [(data, entry) => {
                    return {
                            componentType: 'labelc', 
                            state:{ 
                                text: (data.user), 
                                },
                                styleLabel: {display: 'flex', alignItems: 'center', justifyContent: 'center',background: '', height: 'calc(100% - 10px)'
                            },
                    }
                }]
                
                state.hideHeader = true;

                state.headerMap.actions.componentStateBuilders = [
                    (data, entry) => {
                            return {
                                componentType: 'buttonc', 
                                tooltip: () => {  }, 
                                type: 'button icon-overlay square', 
                                icon: (data.log.type != 1 || data.log.action != 2) ? "" : "fa-eye",
                                disabled: data.log.type != 1 || data.log.action != 2,
                                styleButton: {margin: '0 5px 0 5px', color: "black"},
                                customEvents: {
                                    click: (event) => {
                                        view.loadSingleLog(data.log.id)
                                        .then(response => {
                                            let responseBody = response.data;
                                            if(responseBody.data != null && responseBody.data.data != null){
                                                let shiftUpdateDTO = JSON.parse(responseBody.data.data);
                                                view.loadSinglePlanShift(shiftUpdateDTO.id)
                                                .then(response => {
                                                    view.OpenShiftChangePopup(data, shiftUpdateDTO, response.data)
                                                }).catch(error => {
                                                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.loadErrorX', [view.$t('store.roles.shiftData')]));
                                                })
                                            } else {
                                                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.noData'));
                                            }

                                        }).catch(error => {
                                            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                                        })
                                    }
                                    
                                }
                                
                            }
                        
                    }
                ]
                let mainColumns = ["date", "type", "action", "user"]
                let actionColumns = ["actions"];
                let actionColumnWidth = 10;
                let entries = Object.entries(state.headerMap);
                for(let x in entries){

                    if(mainColumns.includes(entries[x][0])){
                        entries[x][1].width = 20+ '%';
                    }else if(actionColumns.includes(entries[x][0])){
                        entries[x][1].width = actionColumnWidth+ '%';
                    }
                    entries[x][1].key = entries[x][0];
                        
                }
                return state;
            }
        },
        watch: {
            storeId(newVal, oldVal){
                this.refresh();
            },
           
        },
        // methods that implement data logic.
        methods: {
            refresh: function(force = false){
                let view = this;
                this.loading = true;
                this.$helpers.log(this, 'refresh');
                this.$helpers.GetUiDataMap(force).then((uidata) => {
                    this.logTypeMap = this.$helpers.idObjectsArrayToMap(uidata.eventLogTypes);
                    this.logActionMap = this.$helpers.idObjectsArrayToMap(uidata.eventLogActions);

                    this.$helpers.GetEventLogArray(force).then(logs => {
                        
                        view.loading = false;
                    });
                });

            },

            translateLogType(t, multiple = false){
                // TODO: delete this when translations are available in UI Data Map
                switch(t){
                    case 'PLANSHIFT': return multiple? this.$t('shift.main.planShifts') : this.$t('shift.main.planShift');
                    case 'ACTUALSHIFT': return multiple? this.$t('store.settings.shifts') : this.$t('roster.main.shift');
                    case 'EMPLOYEE': return this.$tc('global.general.employee');
                    case 'EMPLOYEETYPE': return this.$tc('pages.employeeContext.planning', multiple ? 2 : 1);
                    case 'EMPLOYEEPREFERENCE': return this.$tc('global.general.absence', multiple ? 2 : 1);
                    case 'EMPLOYEEAVAILABILITY': return this.$tc('global.ui.employeeAvailabilities', multiple ? 2 : 1);
                    case 'EMPLOYEECONTRACT': return this.$tc('pages.employeeData.contract', multiple ? 2 : 1);
                    case 'EMPLOYEEFILE': return multiple? this.$t('store.roles.employeeDocuments') : this.$t('store.roles.employeeDocument');
                    case 'EMPLOYEEWORKBALANCE': return multiple? this.$t('global.menubar.workbalance') : this.$t('global.ui.monthEndClosing');
                    case 'STORESETTINGS': return this.$t('store.settings.title');
                    default: return t;
                }
            },
            translateLogAction(a){
                switch(a){
                    case 'CREATE': return this.$t('global.general.created');
                    case 'UPDATE': return this.$t('global.ui.edited');
                    case 'DELETE': return this.$t('global.ui.deleted');
                    case 'CONFIRM': return this.$t('global.ui.approved').toLowerCase();
                    case 'UNCONFIRM': return 'Bestätigung aufgehoben';
                    case 'PUBLISH': return this.$t('global.ui.published');
                    case 'UNPUBLISH': return this.$t('roster.comp.unpublished');
                    default: return a;
                }
            },
            Close(){
                this.Toggle(false);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    this.toggled = val;
                }else{
                    this.toggled = !this.toggled;
                }
                if(this.toggled){
                   this.refresh();
                }
            },
            loadSingleLog(id){
                let params = {id: id}
                return this.$helpers.GetCall('/api/sec/eventlog', params);
            },
            loadSinglePlanShift(id){
                let params = {id: id}
                return this.$helpers.GetCall('/api/sec/planshift', params);
            },
            OpenShiftChangePopup(logItem, updateDTO, planShift){
                let view = this;
                let description = this.$t('global.ui.logEntry');
                let planShiftText = this.$helpers.getMomentFromStringTZ(planShift.from).locale(this.$i18n.locale).format("DD.MM.YYYY HH:mm")+" - "+this.$helpers.getMomentFromStringTZ(planShift.to).locale(this.$i18n.locale).format("DD.MM.YYYY HH:mm")
                if(view.spotMap[planShift.spotId]){
                    planShiftText+=" "+view.spotMap[planShift.spotId].name;
                }
                if(planShift.employeeId && view.employeeMap[planShift.employeeId]){
                    planShiftText+=" - "+view.employeeMap[planShift.employeeId].lastName.toUpperCase()+" "+view.employeeMap[planShift.employeeId].firstName;
                }
                description += planShiftText+"</br><br/> " + this.$t('global.ui.followingDataChanged') + ": <ul>"
                updateDTO.updateFields.forEach(field => {
                    if(field == "from"){
                        description+="<li>" + this.$t('global.general.from') + ": "+this.$helpers.getMomentFromStringTZ(updateDTO.from).locale(this.$i18n.locale).format("DD.MM.YYYY HH:mm")+"</li>"
                    }
                    else if(field == "to"){
                        description+="<li>" + this.$t('global.general.to') + ": "+this.$helpers.getMomentFromStringTZ(updateDTO.to).locale(this.$i18n.locale).format("DD.MM.YYYY HH:mm")+"</li>"
                    }
                    else if(field == "employeeId"){
                        let employeeName = updateDTO.employeeId == null ? this.$t('roster.view.noEmployees') : (view.employeeMap[updateDTO.employeeId] ? (view.employeeMap[updateDTO.employeeId].lastName.toUpperCase()+" "+view.employeeMap[updateDTO.employeeId].firstName) : this.$t('global.ui.unknown'));
                        description+="<li>" + this.$tc('global.general.employee') + ": "+employeeName+"</li>"
                    }
                    else if(field == "pinned"){
                        description+="<li>" + this.$t('global.ui.pinned') + ": "+(updateDTO.pinned ? this.$t('global.ui.yes') : this.$t('global.ui.no'))+"</li>"
                    }
                })
                description +="</ul>"


                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: [],
                        description: description,
                        selectCallback: function (data) {
                            
                        }
                    },
                    header: this.$t('global.ui.logInformation'),
                    expanded: true,
                    width: "700px",
                    centered: true
                }); 
            },
            Init(parent){
                this.toggled = true;
                this.refresh(true);
            },
        },

    }
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>
    .header.top{
        margin: 10px 0;
    }
    .data-table{
        top: 10px;
        position: relative;
    }

    .eventlog-popup{
        position:fixed;
        display:inline-block;
        height: calc(100vh - 155px);
        overflow: none;
        width: 700px;
        border-radius: 5px;
        z-index: 1000;
        background: var(--bg);
        box-shadow: 2px 2px 3px 1px rgba(0,0,0,0.2);
        padding: 0px;
        border: 1px solid #a5a5a5;

        bottom: 45px;
        right: 100px;
    }

    .eventlog-popup .header {
        padding: 0 24px;
        text-align: right;
        float: right;
        height: 56px;
        width: 100%;
        border-bottom: solid 1px var(--md);
        display: flex;
        justify-content: flex-end;
    }

    .eventlog-popup .header .label {
        text-align: right;
        color: var(--md);
        font-size: 24px;
        font-family: DistrictProBook;
        display: flex;
        align-items: center;
        height: 100%;
    }

    .eventlog-popup .table-container {
        height: calc(100vh - 215px);
        width: 100%;
        overflow-y: scroll;
        overflow-x: hidden;
    }

     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }

    .loading-md.eventlog .fa-spinner{
        position:absolute;
        top: 200px;
        left: 320px;
        margin-right: auto;
        margin-left: auto;
        width: 60px;
        height: 60px;
        font-size: 60px;
        color: var(--md);
        animation-name: spin;
        animation-duration: 2000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        overflow: hidden !important;
    }

    .loading-md.eventlog .loading-text{
        position:absolute;
        top: 320px;
        left: 0;
        right: 0;
        bottom: 0;
        margin-top: 24px;
        width: 100%;
        overflow: hidden !important;
        text-align: center;
        font-size: 24px;
        color: var(--md);
        font-family: DistrictProBook;
    }
</style>
